module.exports = __webpack_public_path__ + "img/debt_relief.dcf96f73.jpg";